function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1865.71,-2536.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17187,0,0,1.17187,1865.71,2536.1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55454,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,104.821L6.285,104.821C2.816,104.821 0,100.443 0,95.051L0,73.915L130.025,73.915L130.025,104.821Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55454,0,0,1,0.00103018,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L219.572,73.915L219.572,95.051C219.572,100.443 216.755,104.821 213.287,104.821L130.025,104.821L130.025,73.915Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55454,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L0,73.915L0,9.77C0,4.378 2.816,0 6.285,0L130.025,0L130.025,73.915Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55454,0,0,1,0.00103018,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,0L213.287,0C216.755,0 219.572,4.378 219.572,9.77L219.572,73.915L130.025,73.915L130.025,0Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10443,0,0,1,0,407.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,104.821L6.285,104.821C2.816,104.821 0,100.443 0,95.051L0,73.915L130.025,73.915L130.025,104.821Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.718096,0,0,1,180.258,407.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L219.572,73.915L219.572,95.051C219.572,100.443 215.006,104.821 208.471,104.821L130.025,104.821L130.025,73.915Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10443,0,0,1,0,407.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L0,73.915L0,9.77C0,4.378 2.816,0 6.285,0L130.025,0L130.025,73.915Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.718096,0,0,1,180.258,407.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,0L208.448,0C215.957,0 219.572,4.378 219.572,9.77L219.572,73.915L130.025,73.915L130.025,0Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3.3433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966274,0,0,1,0,139.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,104.821L6.285,104.821C2.816,104.821 0,100.443 0,95.051L0,73.915L130.025,73.915L130.025,104.821Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.698503,0,0,1,34.8169,139.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L219.572,73.915L219.572,95.051C219.572,100.443 210.457,104.821 206.988,104.821L130.025,104.821L130.025,73.915Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966274,0,0,1,0,139.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L0,73.915L0,9.77C0,4.378 2.816,0 6.285,0L130.025,0L130.025,73.915Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.698503,0,0,1,34.8169,139.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,0L207.947,0C211.415,0 219.572,4.378 219.572,9.77L219.572,73.915L130.025,73.915L130.025,0Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3.11329)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.52505,0,0,1,0,274.566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,104.821L6.285,104.821C2.816,104.821 0,100.443 0,95.051L0,73.915L130.025,73.915L130.025,104.821Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05122,0,0,1,61.6093,274.566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L219.572,73.915L219.572,95.051C219.572,100.443 216.755,104.821 213.287,104.821L130.025,104.821L130.025,73.915Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.52505,0,0,1,0,274.566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,73.915L0,73.915L0,9.77C0,4.378 2.816,0 6.285,0L130.025,0L130.025,73.915Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05122,0,0,1,61.6093,274.566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.025,0L213.287,0C216.755,0 219.572,4.378 219.572,9.77L219.572,73.915L130.025,73.915L130.025,0Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShbar);
export default __webpack_public_path__ + "static/media/shbar.fa0bb47c587cfc95d1b26139339d3cfd.svg";
export { ForwardRef as ReactComponent };